import React from "react"
import Navbar from "../../Common/Navbar"
import Footer from "../../Common/Footer"
import Sidebar from "../../Sidebar/Sidebar"
import ComposeComp from "./Component/ComposeComp"


const Compose=()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea" >
            <Sidebar />
            <ComposeComp />
        </div>
        <Footer />
        </>
    )
}

export default Compose